module.exports = __webpack_public_path__ + "static/media/bankIcon.befae978.svg";